import './App.css'
import 'bootstrap/dist/css/bootstrap.min.css'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import 'react-toastify/dist/ReactToastify.css'
import 'react-calendar/dist/Calendar.css'
import Home from './Pages/Home'
import { Route, Routes, useLocation } from 'react-router-dom'
import FarmerShop from './Pages/FarmerShop'
import SignInPage from './Pages/SignInPage'
import SignUpPage from './Pages/SignupPage'
import ProductDetail from './Pages/ProductDetail'
import Cart from './Pages/Cart'
import AllProduct from './Pages/AllProduct'
import ProfileDetails from './Pages/ProfileDetails'
import Wishlists from './Pages/Wishlists'
import { useEffect } from 'react'
import FarmLabour from './Pages/FarmLabour'
import UserOrders from './Pages/UserOrders'
import PrivacyPolicyPage from './Pages/FooterPages/PrivacyPolicyPage'
import DeliveryPolicyPage from './Pages/DeliveryPolicyPage'
import RefundPolicyPage from './Pages/FooterPages/RefundPolicyPage'
import FaqPage from './Pages/FaqPage'
import TermAndConditionPage from './Pages/FooterPages/TermAndConditionPage'
import InnovativeSolution from './Pages/InnovativeSolution'
import DroneBooking from './Pages/DroneBooking'
import FranchisePage from './Pages/FranchisePage'
import AllBlogsPage from './Pages/AllBlogsPage'
import BlogDetailsPage from './Pages/BlogDetailsPage'
import GetFinancePage from './Pages/GetFinancePage'
import FarmerGaonSe from './Pages/FarmerGaonSe'
import AboutUs from './Pages/AboutUs'
import NotFound from './Pages/NotFound'
import Microfinance from './Pages/FooterPages/Microfinance'
import RentTractor from './Pages/FooterPages/RentTractor'
import AgriOutputEMarketplace from './Pages/FooterPages/AgriOutputEMarketplace'
import QualityAssayingServices from './Pages/FooterPages/QualityAssayingServices'
import FarmerBrand from './Pages/FooterPages/FarmerBrand'
import BuyAgriEquipment from './Pages/FooterPages/BuyAgriEquipment'
import AgriOutput from './Pages/FooterPages/AgriOutput'
import LivestockNutrition from './Pages/FooterPages/LivestockNutrition'
import BookingAgriDrone from './Pages/FooterPages/BookingAgriDrone'
import AgriInputStore from './Pages/FooterPages/AgriInputStore';
import SoilTestingLab from './Pages/FooterPages/SoilTestingLab'
import Consultation from './Pages/FooterPages/Consultation'
import VendorJoinForm from './Pages/VendorJoinForm'

function App () {
  const location = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location.pathname])
  return (
    <div className='App'>
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/farmer-shop' element={<FarmerShop />} />

        <Route path='/gaon-se' element={<FarmerGaonSe/>} />
        <Route path='/all-product' element={<AllProduct />} />
        <Route path='/profile-details/:id' element={<ProfileDetails />} />
        <Route path='/product-details/:id' element={<ProductDetail />} />
        <Route path='/drone-booking' element={<DroneBooking />} />
        <Route path='/cart' element={<Cart />} />
        <Route path='/orders' element={<UserOrders />} />
        <Route path='/wishlist' element={<Wishlists />} />
        <Route path='/hire-farm-labour' element={<FarmLabour />} />
        <Route path='/consultation' element={<Consultation />} />
        

        <Route path='/privacy-policy' element={<PrivacyPolicyPage />} />
        <Route path='/about-us' element={<AboutUs />} />
        <Route path='/delivery-policy' element={<DeliveryPolicyPage />} />
        <Route path='/refund-policy' element={<RefundPolicyPage />} />
        <Route path='/faq' element={<FaqPage />} />
        <Route path='/blogs' element={<AllBlogsPage />} />
        <Route path='/blog-details/:id' element={<BlogDetailsPage />} />
        <Route path='/microfinance' element={<Microfinance />} />
        <Route path='/farmers-brand' element={<FarmerBrand />} />
        <Route path='/quality-assaying-services' element={<QualityAssayingServices />} />
        <Route path='/agri-output-e-marketplace' element={<AgriOutputEMarketplace />} />
        <Route path='/rent-machinery' element={<RentTractor />} />
        <Route path='/buy-agri-equipment' element={<BuyAgriEquipment />} />
        <Route path='/farmercity-agri-output' element={<AgriOutput />} />
        <Route path='/livestock-nutrient' element={<LivestockNutrition />} />
         <Route path='/booking-agri-drone' element={< BookingAgriDrone/>} />
          <Route path='/FC-agri-input-store' element={<AgriInputStore />} />
           <Route path='/soil-testing-lab' element={<SoilTestingLab />} />
        <Route
          path='/progressive-farming-solutions'
          element={<InnovativeSolution />}
        />
        <Route path='/get-finance' element={<GetFinancePage />} />
        <Route path='/term-and-conditions' element={<TermAndConditionPage />} />
        <Route path='/become-a-franchise' element={<FranchisePage />} />
        <Route path='/signup' element={<SignUpPage />} />
        <Route path='/signin' element={<SignInPage />} />
          <Route path='/vendor-form' element={<VendorJoinForm />} />
        <Route path='*' element={<NotFound />} />

        
      </Routes>
    </div>
  )
}

export default App
